import { useSyncExternalStore } from 'react'
import { DEFAULT_BIKE, type BikeParams } from '../analysis/traction'

/**
 * The bike and rider the traction circle is computed for, kept in localStorage. One set for the
 * app, not per session. Missing or broken storage falls back to the defaults.
 */
const KEY = 'mala.bike.v1'
let bike: BikeParams = load()
const listeners = new Set<() => void>()

function load(): BikeParams {
  try {
    const raw = localStorage.getItem(KEY)
    const parsed = raw ? (JSON.parse(raw) as Partial<BikeParams>) : {}
    return sanitize(parsed)
  } catch {
    return DEFAULT_BIKE
  }
}

/** Every field a finite number, else the default for it; new fields need no migration. */
export function sanitize(p: Partial<BikeParams> | null | undefined): BikeParams {
  const out = { ...DEFAULT_BIKE }
  if (!p || typeof p !== 'object') return out
  for (const k of Object.keys(DEFAULT_BIKE) as (keyof BikeParams)[]) {
    const v = p[k]
    if (typeof v === 'number' && Number.isFinite(v)) out[k] = v
  }
  return out
}

export function loadBike(): BikeParams {
  return bike
}

export function saveBike(next: BikeParams): void {
  bike = sanitize(next)
  try {
    localStorage.setItem(KEY, JSON.stringify(bike))
  } catch {
    /* storage may be unavailable */
  }
  for (const f of listeners) f()
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}

export function useBike(): BikeParams {
  return useSyncExternalStore(subscribe, loadBike, () => DEFAULT_BIKE)
}
